jPar.loginAndRegistration.registrationPage = jPar.loginAndRegistration.registrationPage || {};
$j.extend(true, jPar.loginAndRegistration.registrationPage, {
	// Ueberprueft die Formularwerete und stoppt ggf. den submit
	validate: {
		conf: {
			registrationFormName: '#formRegistration',
		},

		init: function init() {
			try {
				const _this = this;

				$j(this.conf.registrationFormName + ' #regFormEmail').on('keyup change', function () {
					if ($j('#regFormEmail').parents('.wdk-form-text').hasClass('has-error')) {
						_this.validateEmail();
					}
				});

				$j(this.conf.registrationFormName + ' input.checkPassword[type=password]').on('focus', function () {
					jPar.wdk.forms.hideError($j('#regPasswordEmptyError'));
					jPar.wdk.forms.hideError($j('#regPasswordNotValidError'));
				});

				$j(this.conf.registrationFormName).on('submit', function (event) {
					_this.validateForm({
						clickFromSocialLogin: $j('#formRegistration').data('clickFromSocialLogin'),
					});

					$j('#formRegistration').data('clickFromSocialLogin', false);

					const isTurnstileInvalid = document.querySelector(`${_this.conf.registrationFormName} peg-turnstile`)?.validate() === false;

					if (jPar.wdk.forms.hasVisibleErrors($j(_this.conf.registrationFormName)) || isTurnstileInvalid) {
						event.preventDefault();
					} else {
						jPar.loginAndRegistration.util.showLoadingAnimation();
					}
				});
			} catch (e) {
				jPar.util.log.error(e.stack, 'jPar.loginAndRegistration.registrationPage.validate.init');
			}
		},

		validateForm: function validateForm(param) {
			param = param || {};

			this.validateSex(param);
			this.validateEmail(param);
			this.validatePassword(param);
		},

		validateSex: function validateSex() {
			// DEV-32423
			if (document.querySelector('#mysexEssexRow') === null) {
				return;
			}

			if (!$j('input[name="mysex"]:checked').length || !$j('input[name="essex"]').val() === '') {
				jPar.wdk.forms.showError($j('#regsexError'));
			} else {
				jPar.wdk.forms.hideError($j('#regsexError'));
			}
		},

		validateEmail: function validateEmail(param) {
			param = param || {};
			const eMailField = $j('#regFormEmail');
			const isEmailEmptyOrNotValidAddress = jPar.util.validate.textfieldIsEmpty(eMailField) || jPar.util.validate.isEmailAddress(eMailField) === false;

			if (param.clickFromSocialLogin === false && isEmailEmptyOrNotValidAddress) {
				jPar.wdk.forms.showError($j('#regEmailError'));
			} else {
				jPar.wdk.forms.hideError($j('#regEmailError'));
			}
		},

		validatePassword: function validatePassword(param) {
			param = param || {};
			if (param.clickFromSocialLogin === true) {
				jPar.wdk.forms.hideError($j('#regPasswordEmptyError'));
				jPar.wdk.forms.hideError($j('#regPasswordNotValidError'));
			} else {
				jPar.wdk.passwordRestrictionBox.checkPasswordRestrictions();

				if (jPar.util.validate.textfieldIsEmpty($j('#regFormPassword'))) {
					jPar.wdk.forms.showError($j('#regPasswordEmptyError'));
					jPar.wdk.forms.hideError($j('#regPasswordNotValidError'));
				} else if (jPar.wdk.passwordRestrictionBox.isPasswordValid() === false) {
					jPar.wdk.forms.hideError($j('#regPasswordEmptyError'));
					jPar.wdk.forms.showError($j('#regPasswordNotValidError'));
				} else {
					jPar.wdk.forms.hideError($j('#regPasswordEmptyError'));
					jPar.wdk.forms.hideError($j('#regPasswordNotValidError'));
				}
			}
		},
	},
});
